module.exports = __webpack_public_path__ + "img/west-2-high-school-director.02b59ec6.png";